var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mango-loader"},[_c('div',{staticClass:"logo-wrapper"},[_c('img',{staticClass:"mango-img",attrs:{"src":_vm.logo,"alt":"Mangxo Logo"}}),_c('div',{staticClass:"loader-text text-h5"},[_vm._v("Proyectos")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }